<div class="container-fluid">
  <div class="row justify-content-between manageaccount mt-3">
    <div class="col-xl-12">
      <div class="d-flex align-items-center justify-content-between">
        <h1 class="fs-4 fw-bold">
          Monthly {{ type === "Tracker" ? "Tracker" : "LR" }} Expense Report :
          {{ month }} {{ year }}
        </h1>

        <button
          class="btn btn-dark btn-sm"
          mat-raised-button
          matTooltip="Back"
          matTooltipPosition="left"
          (click)="backTo()"
        >
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="contentbox mt-3">
    <div class="row customepadding">
      <div class="col-md-12 table-responsive">
        <table
          datatable
          class="row-border hover tablelist"
          *ngIf="LrExpenseArray.length > 0"
        >
          <thead>
            <tr>
              <!-- <td>Month</td> -->
              <td>Supervisor Name</td>
              <td>Company Name</td>
              <td>Amount</td>
              <td>Expense Action</td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let expense of LrExpenseArray">
              <!-- <td>{{user1.month}}</td> -->
              <td
                [routerLink]="[
                  '../../../dateWiseLrExpense',
                  paramId,
                  expense.companyId,
                  expense.supervisorId,
                  year
                ]"
                [queryParams]="{ type: type }"
              >
                {{ expense.supervisorName }}
              </td>

              <td
                [routerLink]="[
                  '../../../dateWiseLrExpense',
                  paramId,
                  expense.companyId,
                  expense.supervisorId,
                  year
                ]"
                [queryParams]="{ type: type }"
              >
                {{ expense.companyName }}
              </td>

              <td
                [routerLink]="[
                  '../../../dateWiseLrExpense',
                  paramId,
                  expense.companyId,
                  expense.supervisorId,
                  year
                ]"
                [queryParams]="{ type: type }"
              >
                {{ expense.amount }}
              </td>

              <td
                [routerLink]="[
                  '../../../dateWiseLrExpense',
                  paramId,
                  expense.companyId,
                  expense.supervisorId,
                  year
                ]"
                [queryParams]="{ type: type }"
              >
                view
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>
